<template>
  <Layout>
    <div class="row">
      <div class="col-sm">
        <div class="card" v-if="!isLoading">
        <div class="card-header">
            <div class="icon-title">
              <div class="icon-holder">
                <img src="../assets/images/buildings.svg" />
              </div>
              <span>{{ $t('total_comp') }}</span>
            </div>
          </div>
          <div class="card-body" >
            <div class="chart-stats">
              <span class="chart-value">{{ data.totalCompanies.data.total}}</span>
              <img src="../assets/images/upTrend.svg" alt="Up Trend"/>
              <span class="chart-percent up">{{ data.totalCompanies.data.percentage}}%</span>
            </div>
            <BarChart :data="data.totalCompanies.list" :suffix="$t('companies')" bar-color="#FAD9C6" bar-color-active="#F09460" />
          </div>
        </div>

        <free-style-shimmer
            :is-loading="isLoading"
            height="240px"
            width="100%"
            border-radius="20px"
            color="#EAECF0"
            style="margin-bottom: 10px"
        />
      </div>
      <div class="col-sm">
        <div class="card" v-if="!isLoading">
          <div class="card-header">
            <div class="icon-title">
              <div class="icon-holder">
                <img src="../assets/images/brifecase-tick.svg" />
              </div>
              <span>{{ $t('active_companies') }}</span>
            </div>
          </div>
          <div class="card-body">
            <div class="chart-stats">
              <span class="chart-value">{{ data.totalActiveCompanies.data.total}}</span>
              <img src="../assets/images/upTrend.svg" alt="Up Trend"/>
              <span class="chart-percent up">{{ data.totalActiveCompanies.data.percentage}}%</span>
            </div>
            <BarChart :data="data.totalActiveCompanies.list" :suffix="$t('companies')" bar-color="#D1E7D2" bar-color-active="#3DA33E" />
          </div>
        </div>

        <free-style-shimmer
            :is-loading="isLoading"
            height="240px"
            width="100%"
            border-radius="20px"
            color="#EAECF0"
            style="margin-bottom: 10px"
        />
      </div>
      <div class="col-sm">
        <div class="card" v-if="!isLoading">
          <div class="card-header">
            <div class="icon-title">
              <div class="icon-holder">
                <img src="../assets/images/programs.svg" />
              </div>
              <span>{{ $t('programs_assigned') }}</span>
            </div>
          </div>
          <div class="card-body">
            <div class="chart-stats">
              <span class="chart-value">{{ data.totalProgramsCompanyAssigned.data.total}}</span>
              <img src="../assets/images/downTrend.svg" alt="Down Trend"/>
              <span class="chart-percent down">{{ data.totalProgramsCompanyAssigned.data.percentage}}%</span>
            </div>
            <BarChart :data="data.totalProgramsCompanyAssigned.list" :suffix="$t('programs')" bar-color="#EBEDFB" bar-color-active="#4A68F8" />
          </div>
        </div>


        <free-style-shimmer
            :is-loading="isLoading"
            height="240px"
            width="100%"
            border-radius="20px"
            color="#EAECF0"
            style="margin-bottom: 10px"
        />
      </div>

    </div>
    <div class="table-holder">
      <h3 class="table-title">{{ $t('all_companies') }}</h3>
      <CompanyTable :loading="isLoading" :companies="tableData.data" :refresh-callback="() => handlePage(1)" />
      <div class="pagination-align-center">
        <Pagination :total-items="tableData.total" :per-page="20" :current-page="currentPage" :on-page-change="handlePage"/>
      </div>
    </div>
  </Layout>
</template>

<script>
import BarChart from '@/components/charts/BarChart.vue'
import Layout from "@/components/layouts/Layout.vue";
import AvatarArray from "@/components/AvatarArray.vue";
import companyService from "@/service/companyService";
import Pagination from "@/components/Pagination.vue";
import CompanyTable from "@/components/tables/Company/CompanyTable.vue";

export default {
  name: 'Home',
  components: {
    CompanyTable,
    Pagination,
    AvatarArray,
    Layout,
    BarChart,
  },
  data() {
    return {
      isLoading: true,
      data: {},
      tableData: {},
      currentPage: 1
    }
  },
  watch: {
    $route() {
      this.handlePage(1);
    }
  },
  methods: {
    handlePage(page) {
      if (this.isLoading && page !== 1) return;
      this.isLoading = true;
      this.currentPage = page;
      const routeQuery = this.$route.query;
      const tempFilters = [];

      if (routeQuery.searchText) {
        tempFilters.push({
          key: 'searchText',
          value: routeQuery.searchText
        });
      }

      if (routeQuery.addedDate) {
        tempFilters.push({
          key: 'addedDate',
          value: routeQuery.addedDate
        });
      }

      if (routeQuery.addedDateEnd) {
        tempFilters.push({
          key: 'addedDateEnd',
          value: routeQuery.addedDateEnd
        });
      }

      if (routeQuery.programNumberMin) {
        tempFilters.push({
          key: 'programNumberMin',
          value: routeQuery.programNumberMin
        });
      }

      if (routeQuery.programNumberMax) {
        tempFilters.push({
          key: 'programNumberMax',
          value: routeQuery.programNumberMax
        });
      }

      if (routeQuery.userAmountMax) {
        tempFilters.push({
          key: 'userAmountMax',
          value: routeQuery.userAmountMax
        });
      }

      if (routeQuery.userAmountMin) {
        tempFilters.push({
          key: 'userAmountMin',
          value: routeQuery.userAmountMin
        });
      }

      if (routeQuery.status) {
        if(routeQuery.status === "1") {
        tempFilters.push({
          key: 'status',
          value: "1"

        })}
        else if(routeQuery.status==="0"){
          tempFilters.push({
            key: 'status',
            value: "0"
          })
        }
      }

      companyService.getCompanies(page, tempFilters).then(response => {
        this.data = response.data.data;
        this.tableData = response.data.data.store;

        if (this.tableData.total === 1
            && this.tableData.data.length === 1
            && tempFilters.length === 0
            && page === 1) {
          const companyId = this.tableData.data[0].companyId;
          this.$router.replace(`/companies/detail/${companyId}`);
          return;
        }

        this.isLoading = false;
      })
    },

  }
}
</script>

<style scoped>
.icon-title {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 5px;
}

.icon-title span {
  font-family: 'euclid_medium', sans-serif;
  font-size: 18px;
  white-space: nowrap
}

.card {
  margin-bottom: 10px;
}

.icon-holder {
  background-color: #EAECF0;
  border-radius: 8px;
  height: 28px;
  width: 28px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 5px;
}

.icon-holder img {
  cursor: default;
}

.chart-stats {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-bottom: 10px;
}

.chart-value {
  font-family: 'euclid_medium', sans-serif;
  font-size: 28px;
  margin-right: 10px;
}

.chart-percent {
  font-family: 'euclid_semi_bold', sans-serif;
  font-size: 12px;
  margin-left: 5px;
}

.chart-percent.up {
  color: #3DA33E;
}

.chart-percent.down {
  color: #F09460;
}

.table-holder {
  margin-top: 20px;
}

.table-title {
  font-family: 'euclid_medium', sans-serif;
  font-size: 20px;
  color: #040C2D;
  margin-bottom: 20px;
}
</style>
